import React from 'react';
import ClubsList from './ClubsList';
import { runningPath } from '../utils/paths';

/**
 * Running-app clubs directory — forces RUNNING sport and running-app paths.
 */
const RunningClubsList = () => {
  return (
    <ClubsList
      forcedSport="RUNNING"
      registerPath={runningPath('/clubs/register')}
    />
  );
};

export default RunningClubsList;
